export const useABTestingStore = defineStore('abtesting', () => {
  const cardMode = ref('branch') // branch or product

  return { cardMode }
})
